<template>
  <a class="card mb-4" :href="link" target="_self">
    <div class="card-body">
      <h3 class="card-title text-center">
        {{channel.name}}
      </h3>
    </div>
  </a>
</template>

<script>
export default {
  name: 'ChannelCard',
  props: [
    'channel'
  ],
  data () {
    return {
    }
  },
  mounted () {
  },
  computed: {
    link () {
      return `#/channels/${this.channel.id}`
    },
    bgStyle () {
      return {
        'background-image': `url("${this.channel.preview}")`,
        'background-size': 'contain',
        'background-repeat': 'no-repeat',
        'background-position': '50% 50%'
      }
    }
  },
  methods: {
  }
}
</script>

<style scoped>
  a.card, a.card:hover, a.card:focus {
    display: block;
    text-decoration: none;
    color: inherit;
    transition: transform 100ms ease-in-out;
  }
  a.card:hover {
    transform: scale(1.05);
  }
  .card-title, .card-text {
    text-align: left;
    font-size: 1.3rem;
    margin-bottom: 0;
  }
  .card-title {
    font-weight: 800;
  }
  .card-body {
    padding: 30px 5px;
  }
  .no-preview {
    color: rgba(255,255,255,0.5);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .timeframe {
    position: absolute;
    left: 5px;
    top: 5px;
  }
</style>




// WEBPACK FOOTER //
// src/components/ChannelCard.vue